module.exports = __webpack_public_path__ + "static/media/bulletinLogo.68a880a1.png";